
























import { Component, Prop, Vue } from 'vue-property-decorator'
import { GeneralSummaryData } from '@/models/api/common/SummaryResultTypes.vue'

@Component
export default class ScoreSummaryTable extends Vue {
  @Prop()
  tableLabels!: { key: string; name: string }

  @Prop()
  summaryData!: GeneralSummaryData

  @Prop({ default: false })
  isStudyModeRecommend!: boolean

  private convertValue(value: number): string {
    return value !== null ? value.toFixed(1) : '—'
  }
}
